import { render, staticRenderFns } from "./MalfunctionCalendar.vue?vue&type=template&id=7fb36db9&scoped=true"
import script from "./MalfunctionCalendar.vue?vue&type=script&lang=ts"
export * from "./MalfunctionCalendar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb36db9",
  null
  
)

export default component.exports